// src/components/WorkExperienceTimeline.jsx

import {
  VerticalTimeline,
  VerticalTimelineElement,
} from "react-vertical-timeline-component";
import "react-vertical-timeline-component/style.min.css";

import styles from "./WorkExperienceTimeline.module.css";
import "./ProjectsSection.css";

import centml from "../media/centml.png";
import jublia from "../media/jublia_v2.jpg";
import panasonic from "../media/panasonic_logo_v2.jpg";
import sutd from "../media/sutd_logo.jpg"

const jobs = [
  {
    title: "Research Assistant",
    company: "Singapore University of Technology and Design",
    startDate: "Jul 2025",
    endDate: "Present",
    description: "Worked on Agentic VS Code Extension Assistant for students",
    icon: sutd,
  },
  {
    title: "Software Engineer Contract",
    company: "Panasonic R&D",
    startDate: "May 2024",
    endDate: "Sept 2024",
    description: "Worked on AI Agent for wellness, and Movie Q&A",
    icon: panasonic,
  },
  {
    title: "Backend Engineer Intern",
    company: "Jublia",
    startDate: "Aug 2022",
    endDate: "Dec 2022",
    description: "Worked on Jublia Sense backend",
    icon: jublia,
  },
  {
    title: "Software Engineer Intern",
    company: "The Collective",
    startDate: "May 2021",
    endDate: "Sept 2021",
    description:
      "Worked alongside founders to build startup, helped with implementing shop listing pages based on Figma Designs",
    icon: centml,
  },
];

export default function WorkExperienceTimeline() {

  return (
    <section className="projects-section" id="experience">
      {/* Header matches ProjectsSection */}
      <div className="projects-header">
        <h2>Work Experience</h2>
        <p className="projects-subtitle">Timeline</p>
      </div>

      {/* Timeline content */}
      <div className={styles.timeline}>
        <VerticalTimeline animate layout="1-column">
          {jobs.map((job, index) => (
            <VerticalTimelineElement
              key={index}
              className={styles.verticalTimelineElement}
              date={`${job.startDate} - ${job.endDate}`}
              dateClassName={styles.dateStyle}
              contentStyle={{
                background:
                  "linear-gradient(135deg, rgba(0, 0, 0, 0.6), rgba(128, 128, 128, 0.6))",
                backgroundSize: "250% 100%",
                color: "#fff",
                borderRadius: 16,
                border: `1px solid rgba(255,255,255,0.10)`,
                boxShadow: "0 18px 60px rgba(0,0,0,0.35)",
                backdropFilter: "blur(10px)",
              }}
              contentArrowStyle={{
                borderRight: "7px solid rgba(255,255,255,0.12)",
              }}
              iconStyle={{
                background: "rgba(0,0,0,0.35)",
                boxShadow: `0 0 0 2px rgba(255,255,255,0.10), 0 12px 30px rgba(0,0,0,0.35)`,
                borderRadius: 999,
              }}
              icon={
                <img
                  src={job.icon}
                  alt={`${job.company} logo`}
                  className={styles.iconImage}
                />
              }
            >
              <h3 className="vertical-timeline-element-title">{job.title}</h3>
              <h4 className="vertical-timeline-element-subtitle">{job.company}</h4>
              <p className={styles.jobDescription}>{job.description}</p>


            </VerticalTimelineElement>
          ))}
        </VerticalTimeline>
      </div>
    </section>
  );
}
